// Standalone full-document render for mattressguides.com pages (#34743).
// Deliberately NOT PageSkeleton: no site header/footer or chrome scripts.
// Editors own all scripts and styles inside the body's raw-HTML blocks.
import React from "react";

import { templates } from "@reactivated";

import {
    StreamField,
    StreamFieldBlockMap,
} from "@thelabnyc/thelabui/src/components/StreamField";

type Value = templates.MattressGuidesPageTemplate["page"]["body"]["value"];

const bodyMap: StreamFieldBlockMap<Value> = {
    // suppressHydrationWarning: editor-authored scripts run before hydration
    // and routinely mutate their own markup.
    html: (block) => (
        <div
            dangerouslySetInnerHTML={{ __html: block.value }}
            suppressHydrationWarning={true}
        />
    ),
};

export const Template = (props: templates.MattressGuidesPageTemplate) => {
    return (
        <html lang="en">
            <head>
                <meta charSet="utf-8" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
                <title>{props.page.seo_title || props.page.title}</title>
                {props.page.search_description && (
                    <meta
                        name="description"
                        content={props.page.search_description}
                    />
                )}
            </head>
            <body>
                <StreamField
                    value={props.page.body.value}
                    components={bodyMap}
                />
            </body>
        </html>
    );
};
